namespace GeniuzPOS.Administration {
    export interface CsVatTypeRow {
        Id?: number;
        VatType?: string;
        VatTypeDesc?: string;
        FullName?: string;
    }

    export namespace CsVatTypeRow {
        export const idProperty = 'VatType';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Administration.CsVatType';
        export const lookupKey = 'Administration.CsVatType';

        export function getLookup(): Q.Lookup<CsVatTypeRow> {
            return Q.getLookup<CsVatTypeRow>('Administration.CsVatType');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:เกี่ยวกับสินค้า:อัตราภาษี:Modify';

        export declare const enum Fields {
            Id = "Id",
            VatType = "VatType",
            VatTypeDesc = "VatTypeDesc",
            FullName = "FullName"
        }
    }
}
